import { createStore, applyMiddleware, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import { disbursements } from './disbursements/reducer'
import { saveDisbursementMiddleware } from './disbursements/storage'
import { myAccount } from './myAccount/reducer'
import { transactionDetails } from './transactionDetails/reducer'
import { deposit } from './deposit/reducer'
import { depositRequests } from './depositRequests/reducer'
import { simulateDeposit } from './simulateDeposit/reducer'
import { withdraw } from './withdraw/reducer'
import { verification } from './verification/reducer'
import { verificationIndo } from './verificationIndo/reducer'
import { merchantUsers } from './merchantUser/reducer'
import { merchantUserDetails } from './merchantUserDetails/reducer'
import { developerTools } from './developerTools/reducer'
import { internalTools } from './internalTools/reducer'
import { businessVerification } from './businessVerification/reducer'
import { landingPage } from './landingPage/reducer'
import { route } from './route/reducer'
import { sandbox } from './sandbox/reducer'
import { transactions } from './transactions/reducer'
import { indoTransactions } from './indoTransactions/reducer'
import { invoicing } from './invoicing/reducer'
import { invoicingDetails } from './invoicingDetails/reducer'
import { team } from './team/reducer'

export const rootReducer = combineReducers({
  disbursements,
  myAccount,
  transactionDetails,
  deposit,
  depositRequests,
  simulateDeposit,
  withdraw,
  verification,
  verificationIndo,
  merchantUsers,
  merchantUserDetails,
  developerTools,
  internalTools,
  businessVerification,
  landingPage,
  route,
  sandbox,
  transactions,
  indoTransactions,
  invoicing,
  invoicingDetails,
  team,
})

const middlewares = [thunk, saveDisbursementMiddleware]
const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middlewares)))

export default store
